module.exports = __webpack_public_path__ + "img/coupon_bg.ed755b41.png";